import React from 'react'
import { useTranslation } from 'react-i18next'
import { StatisticsDashboard } from '@cbgms/api/modules/statistics'
import GenericMonitorChart from './GenericMonitorChart'

const MonitorInvoicesChart: React.FC<{ data: StatisticsDashboard[] }> = props => {
  const { t } = useTranslation()

  return <GenericMonitorChart data={props.data} title={t('global.stats.invoices')} dataSelector={row => row.TotalInvoices} />
}

export default MonitorInvoicesChart
